/** @module csi/image/ImageCancelCrop **/
define([
	"dojo/_base/lang",
	"csi/def/Action",
	"csi/view/PluginFactory",
	"csi/view/ToolbarPluginButton",
	"csi/image/ImageEditorPluginMixin"
], function(lang,Action,PluginFactory,ToolbarPluginButton,ImageEditorPluginMixin) {

	return PluginFactory.declare("cancelcrop", [ToolbarPluginButton, ImageEditorPluginMixin], {
		/**
		 * Set the action for cancelling cropper action
		 */
		constructor: function() {
			this.defAction = lang.mixin(new Action(), {
				m_id: "ImageEditorCancelCrop",
				m_onAction: "cancelCrop"
			});
			this.defAction.setMaterialIcon("cancel");
			this.defAction.resolve();
		}
	});
});